 
import { useAppDispatch } from '@store/hooks';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import { GetCurrenciesList, InsertCurrencies } from '@store/NTX/Currency/currencySlice';
import { Card } from '@components/card/card';
import * as Yup from 'yup';

const Add = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  // قائمة العملات الشائعة
  const commonCurrencies = [
    {
      code: 'SAR',
      name: 'Saudi Riyal',
      nameAr: 'الريال السعودي',
      symbol: 'ر.س'
    },
    {
      code: 'USD',
      name: 'United States Dollar',
      nameAr: 'الدولار الأمريكي',
      symbol: '$'
    },
    {
      code: 'EUR',
      name: 'Euro',
      nameAr: 'اليورو',
      symbol: '€'
    },

    {
      code: 'EGP',
      name: 'Egyptian Pound',
      nameAr: 'الجنيه المصري',
      symbol: 'ج.م'
    },

    {
      code: 'CNY',
      name: 'Chinese Yuan',
      nameAr: 'اليوان الصيني',
      symbol: '¥'
    },
    {
      code: 'JPY',
      name: 'Japanese Yen',
      nameAr: 'الين الياباني',
      symbol: '¥'
    },
    {
      code: 'QAR',
      name: 'Qatari Riyal',
      nameAr: 'الريال القطري',
      symbol: 'ر.ق'
    },
    {
      code: 'GBP',
      name: 'British Pound',
      nameAr: 'الجنيه الإسترليني',
      symbol: '£'
    },
    {
      code: 'KWD',
      name: 'Kuwaiti Dinar',
      nameAr: 'الدينار الكويتي',
      symbol: 'د.ك'
    },

    {
      code: 'OMR',
      name: 'Omani Rial',
      nameAr: 'الريال العماني',
      symbol: 'ر.ع.'
    },

    {
      code: 'TRY',
      name: 'Turkish Lira',
      nameAr: 'الليرة التركية',
      symbol: '₺'
    },
    {
      code: 'YER',
      name: 'Yemeni Rial',
      nameAr: 'الريال اليمني',
      symbol: 'ر.ي'
    }
  ];

  // إنشاء schema للتحقق باستخدام Yup
  const validationSchema = Yup.object({
    currencyCode: Yup.string().required(t('Required')),

    description: Yup.string().required(t('Required')),
    enabledFlag: Yup.boolean()
  });

  const formik = useFormik({
    initialValues: {
      currencyCode: '',
      description: '',
      enabledFlag: false
    },
    validationSchema,
    onSubmit: values => {
      dispatch(
        InsertCurrencies({
          currencyCode: values.currencyCode,
          description: values.description,
          enabledFlag: values.enabledFlag
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            document.getElementById('closeModalForm')?.click();
            dispatch(GetCurrenciesList());
            formik.resetForm();
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  // دالة لاختيار عملة من القائمة
  const handleCurrencySelect = (currency: any) => {
    formik.setValues({
      currencyCode: currency.code,
      description: currency.name,
      enabledFlag: true
    });
  };

  const { values, errors, touched, handleChange } = formik;

  return (
    <>
      <Form onSubmit={formik.handleSubmit}>
        <div className='row'>
          {/* زر عرض العملات الشائعة */}

          {/* قائمة العملات الشائعة */}
          <div className='col-xl-12 mb-4'>
            <Card className='border-0 shadow-sm'>
              <Card>
                <div className='card-header  border-bottom py-3'>
                  <h6 className='card-title mb-0 text-muted fw-semibold'>{t('العملات الشائعة')}</h6>
                </div>
                <div className='card-body p-3'>
                  <div className='row g-2'>
                    {commonCurrencies.map((currency, index) => (
                      <div key={index} className='col-md-6 col-lg-4'>
                        <button
                          type='button'
                          className='btn   w-100 text-start p-3 rounded-2 border'
                          onClick={() => handleCurrencySelect(currency)}
                          style={{
                            transition: 'all 0.2s ease'
                          }}
                        >
                          <div className='d-flex justify-content-between align-items-center'>
                            <div>
                              <strong className='text-darkي d-block'>{currency.code}</strong>
                              <small className='text-muted' style={{ fontSize: '0.8rem' }}>
                                {i18n.language === 'ar' ? currency.nameAr : currency.name}
                              </small>
                            </div>
                            <span className='text-theme fw-bold' style={{ fontSize: '1.1rem' }}>
                              {currency.symbol}
                            </span>
                          </div>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </Card>
            </Card>
          </div>

          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('CurrencyName')}</label>
              <Form.Control
                disabled
                className='form-control form-control-lg'
                type='text'
                autoComplete='off'
                name='description'
                onChange={handleChange}
                value={values.description}
                isInvalid={!!(touched.description && errors.description)}
                // placeholder={t('SelectFromListOrType')}
              />
              <div className='text-danger small'>{touched.description && errors.description}</div>
            </div>
          </div>

          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('CurrencyCode')}</label>
              <Form.Control
                disabled
                className='form-control form-control-lg'
                type='text'
                autoComplete='off'
                name='currencyCode'
                onChange={handleChange}
                value={values.currencyCode}
                isInvalid={!!(touched.currencyCode && errors.currencyCode)}
                // placeholder={t('SelectFromListOrType')}
                style={{ textTransform: 'uppercase' }}
                maxLength={3}
              />
              <div className='text-danger small'>{touched.currencyCode && errors.currencyCode}</div>
            </div>
          </div>

          {/* <div className='col-xl-2'>
            <div className='form-group mb-3'>
              <Form.Check
                style={{ margin: '10px 20px' }}
                className='pt-1 pb-2 ms-auto'
                type='checkbox'
                label={t('Active')}
                name='enabledFlag'
                checked={formik.values.enabledFlag}
                onChange={formik.handleChange}
              />
            </div>
          </div> */}
        </div>
        <hr />
        <div className='text-end'>
          <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1'>
            {formik.isSubmitting ? (
              <div className='spinner-border spinner-border-sm me-2'></div>
            ) : (
              <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
            )}
            {t('Add')}
          </button>
          <button
            type='button'
            className=' btn btn-lg me-1 btn-default mb-1'
            data-bs-dismiss='modal'
            id='closeModalForm'
          >
            <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
          </button>
        </div>
      </Form>
    </>
  );
};

export default Add;
